export const SET_ASSETS = 'SET_ASSETS';
export const SET_IS_FETCHING_ASSETS = 'SET_IS_FETCHING_ASSETS';
